import type { getCategoryData } from '../getCategoryData';

/**
 * This function returns the categoryId for the glycerin payload.
 * The categoryId is either the `categoryIdSearchParam` or the last `id` of the `categoryPath`.
 * If both are not given, it returns `undefined`.
 *
 * The `categoryIdSearchParam` is the categoryId (nav-c) from the URL search params.
 * It has to have priority over the `categoryPath`. -> see comment: https://empiriecom.atlassian.net/browse/INFORM-3418
 */
export const getGlycerinCategoryId = (
  categoryPath: ReturnType<typeof getCategoryData>['categoryPath'],
  categoryIdSearchParam: string | null,
) => ({
  categoryId:
    categoryIdSearchParam ||
    (categoryPath.length > 0 ? categoryPath[categoryPath.length - 1].id : undefined),
});
